import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';

interface SetupModalProps {
  visible: boolean;
  onDismiss: () => void;
  onAccept: () => void;
  onEnterLength: () => void;
}

const SetupModal: React.FC<SetupModalProps> = ({
  visible,
  onDismiss,
  onAccept,
  onEnterLength
}) => {
  return (
    <Dialog open={visible} onClose={onDismiss} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 700, padding: 2 }}>
        Click START to answer the length calculation wizard.
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body1"
          sx={{
            fontSize: 16,
            fontWeight: 700,
            color: 'red',
            textAlign: 'center',
            my: 1
          }}
        >
          Warning!
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: 16,
            fontWeight: 700,
            color: 'red',
            textAlign: 'center',
            my: 1
          }}
        >
          If you start wizard the OFFSET and Direction will be RESET to DEFAULT
          values.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', flexDirection: 'column' }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onAccept}
          sx={{ fontWeight: 700, my: 1 }}
        >
          START
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          onClick={onDismiss}
          sx={{ fontWeight: 700, my: 1 }}
        >
          Cancelar
        </Button>
        <Button
          variant="text"
          onClick={onEnterLength}
          sx={{
            color: 'gray',
            fontWeight: 700,
            fontSize: 15,
            textAlign: 'center',
            mt: 1
          }}
        >
          Enter Length Manually
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SetupModal;
